import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_502: DocMigration = {
  maxSchemaVersion: "0.0.502",
  description: "Add tags to content templates",
  apply(json: any): any {
    for (const id of Object.keys(json.contentTemplates)) {
      json.contentTemplates[id].tags = {};
    }

    return json;
  },
};

export default migration_0_0_502;
